import { useState } from "react";

import Box from '@mui/material/Box';
//import Modal from '@mui/material/Modal';

import { getModalStyle } from '@/utils/Modal';
import { getLanguages } from "@/utils/Language.jsx";

import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';

//import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
//import Button from '@/components/Button';

//import LanguageIcon from '@mui/icons-material/Language';

export default function LanguageModal({t, open, setOpen, language, handleLanguage, fullScreen}){

    const { sxDialog/*, sxCloseIcon, sxList*/ } = getModalStyle();

    const [ languages ] = useState(getLanguages());

    const handleClose = () => setOpen(false);

    {/*
    <ListItem 
        key={'language_'+index}
        sx={item?.value === language ? sxListItemSelected : sxListItem} 
        disablePadding                                 
    >
        <ListItemButton onClick={() => handleLanguage(item?.value)}>
            <ListItemAvatar>
                <Avatar sx={sxAvatar}>
                    <LanguageIcon fontSize="medium"/>
                </Avatar>
            </ListItemAvatar>                                    
            <ListItemText primary={item?.name} />
        </ListItemButton>                                
    </ListItem>
    */}

    return (
        
        <Dialog 
            container={fullScreen?.active ? fullScreen?.node?.current : null}
            sx={sxDialog}
            onClose={handleClose} 
            open={open}
            //fullWidth={true}
            //maxWidth='sm'            
        >
            <DialogTitle className='modal-title'>
                {t('language.title')}
            </DialogTitle>
            {/*
            <IconButton                    
                onClick={handleClose}
                sx={sxCloseIcon}
            >
                <CloseIcon />
            </IconButton>
            */}
            <DialogContent className='modal-content text-center !pb-0'>
                {
                    languages && languages.length > 0 && languages.map((item,index) => (                                                
                        <div   
                            key={'language_'+index}                     
                            className={`language-item ${item?.value === language ? 'language-item-selected' : ''}`}
                            onClick={() => handleLanguage(item?.value)}
                        >
                            {item?.name}
                        </div>                                                
                    ))
                }
            </DialogContent>
            {/*
            <div className="modal-buttons">                
                <div className=''>
                    <CloseIcon className='action-button-modal text-black' onClick={handleClose}/>
                </div>
            </div>
            */}
        </Dialog>

  );
}